module.exports = __webpack_public_path__ + "static/img/client-4.9443be4a.png";